import { createIcon } from '@chakra-ui/react'

// Box Icons / Solid / Circle
export const OmCircle = createIcon({
  displayName: 'Circle',
  viewBox: '0 0 24 24',
  d: 'M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z',
})
